import { useEffect, useState } from 'react';
import './terms.css';
import TermsService from '../../service/terms/terms';
import { useNavigate } from 'react-router-dom';
import ScrollToTopButton from '../components/ScrollToTopButton';
import PageTop from '../components/pageTop/PageTop';
import styled from 'styled-components';
import Footer from '../components/footer/Footer';
import Menu from '../components/menu/Menu';

interface ContentItem {
  seq: number;
  title: string;
  content:
    | {
        clause_idx: number;
        seq: number;
        title: string;
        content: {
          clause_idx: number;
          seq: number;
          title: string;
          content: any;
        }[];
      }[]
    | null;
  clause_idx: number;
}

interface Term {
  seq: number;
  title: string;
  content: ContentItem[];
  terms_idx: number;
}

interface ContentItem2 {
  seq: number;
  title: string;
  content: string | null;
  clause_idx: number;
}

interface Term2 {
  seq: number;
  title: string;
  content: ContentItem2[];
  terms_idx: number;
}

const ServiceTerms = () => {
  const navigate = useNavigate();

  const [verisionList, setVersionList] = useState<
    { version: 0; create_date: '' }[]
  >([]);

  const [selectedDate, setSelectedDate] = useState<{
    version: number;
    create_date: string;
  } | null>(null);

  const [terms, setTerms] = useState<Term[]>([]);
  const [addendum, setAddendum] = useState<Term2[]>([]);
  const [openMenu, setOpenMenu] = useState(false);

  const getDateList = async () => {
    try {
      const res = await TermsService.version('D');
      setVersionList(res.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDateList();
  }, []);

  const getTerms = async (version: number) => {
    try {
      const res = await TermsService.terms(version, 'D');
      setAddendum(res.result.addendum);
      setTerms(res.result.list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedDate) {
      getTerms(selectedDate.version);
    } else if (verisionList.length > 0) {
      getTerms(verisionList[0].version);
    }
  }, [selectedDate, verisionList]);

  return (
    <Container id="termsContainer">
      <ScrollToTopButton />
      <PageTop text="이용약관" setOpenMenu={setOpenMenu} />
      <div className="wrap">
        <div className="terms-inner">
          <div className="terms-title">
            <span>땅집고 옥션 서비스 이용약관</span>
            <div className="version-select">
              <select
                className="select-non-border"
                name=""
                id=""
                onChange={(e) => {
                  const selectedVersion = verisionList.find(
                    (v) => v.version === Number(e.target.value),
                  );
                  if (selectedVersion) {
                    setSelectedDate(selectedVersion);
                  }
                }}
                value={selectedDate?.version || ''}
              >
                {verisionList.map((item) => (
                  <option key={item.version} value={item.version}>
                    {item.create_date}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="terms-content-box">
            {terms.map((term) => (
              <div className="terms-content-item" key={term.terms_idx}>
                <div
                  className="terms-content-item-title"
                  dangerouslySetInnerHTML={{
                    __html: term.title.replace(/\r\n/g, '<br>'),
                  }}
                ></div>
                <div className="terms-content-item-text">
                  {term.content.map((item) => (
                    <div key={item.clause_idx}>
                      <p>
                        {item.seq}. {item.title}
                      </p>
                      {item.content &&
                        item.content.map((content) => (
                          <div style={{ fontSize: '13px', marginLeft: '4px' }}>
                            {content.seq}
                            {')'} {content.title}
                            {content.content &&
                              content.content.map((c, idx) => (
                                <div key={idx}>- {c.title}</div>
                              ))}
                          </div>
                        ))}
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <div>
              <div
                className="terms-content-item-title"
                style={{ marginBottom: '6px' }}
              >
                -부칙-
              </div>
              {addendum.map((term) => (
                <div className="terms-content-item" key={term.terms_idx}>
                  <div
                    className="terms-content-item-title"
                    dangerouslySetInnerHTML={{
                      __html: term.title.replace(/\r\n/g, '<br>'),
                    }}
                  ></div>
                  <div className="terms-content-item-text">
                    {term.content.map((item) => (
                      <div key={item.clause_idx}>
                        <p>
                          {item.seq}. {item.title}
                        </p>
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              typeof item.content === 'string'
                                ? item.content.replace(/\r\n/g, '<br>')
                                : '',
                          }}
                        ></p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="divider" />
          <div
            className="home-button"
            onClick={() => {
              navigate('/');
            }}
          >
            홈으로
          </div>
        </div>
      </div>

      <Footer />
      {openMenu && <Menu page="terms/service" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};

export default ServiceTerms;

const Container = styled.div`
  width: 100%;
  height: 100%; /* 화면 높이만큼 설정 */
  overflow-y: auto; /* 세로 스크롤 가능하게 설정 */
  margin: 0 auto;
  background-color: #fff;
`;
